import React, { useState, useEffect } from 'react';
import { FaArrowUp } from 'react-icons/fa';
import useHaptic from '../../hooks/useHaptic';

const BackToTop = () => {
  const [isVisible, setIsVisible] = useState(false);
  const haptic = useHaptic();

  // Show button when page is scrolled up to given distance
  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  // Set the top coordinate to 0 and make smooth scrolling
  const scrollToTop = () => {
    haptic.medium();
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  return (
    <div className={`fixed bottom-24 md:bottom-8 right-6 md:right-32 z-[100] transition-all duration-300 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10 pointer-events-none'}`}>
      <button 
        onClick={scrollToTop} 
        className="w-12 h-12 bg-red-600 hover:bg-red-700 text-white rounded-2xl flex items-center justify-center shadow-xl shadow-red-600/20 transition-all hover:scale-110 active:scale-95"
        aria-label="Back to top"
      >
        <FaArrowUp size={20} />
      </button>
    </div>
  );
};

export default BackToTop;
